export default "__VITE_ASSET__vyqtw$QE__"